import { FormTemplate } from '@employ-engage/data';
import ConfirmationModal from '../confirmation-modal/confirmation-modal';
import { useTranslation } from 'react-i18next';
import { useMutation } from '@apollo/client';
import { DELETE_FORM_TEMPLATE } from '../api';

export interface DeleteTemplateConfirmationModalProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  templateSelectedForDeletion?: FormTemplate;
  refetchFormTemplates: () => void;
}

export function DeleteTemplateConfirmationModal({
  open,
  setOpen,
  templateSelectedForDeletion,
  refetchFormTemplates,
}: DeleteTemplateConfirmationModalProps) {
  const { t } = useTranslation(['common']);
  const [deleteFormTemplate] = useMutation(DELETE_FORM_TEMPLATE);
  const deleteTemplate = () => {
    if (!templateSelectedForDeletion) return;

    deleteFormTemplate({
      variables: { id: templateSelectedForDeletion?.id },
    }).then(() => {
      refetchFormTemplates();
      setOpen(false);
    });
  };

  return (
    <ConfirmationModal
      text={t('confirm-template-deletion', {
        templateName: templateSelectedForDeletion?.name,
      })}
      open={open}
      setOpen={setOpen}
      onConfirm={deleteTemplate}
      onCancel={() => setOpen(false)}
    />
  );
}

export default DeleteTemplateConfirmationModal;
